import { createVanIconComponent } from "./van"

const Service = createVanIconComponent("service")
export default Service
